
import React from "react";
import { EstruturasList } from "@/components/solar/configuracao/EstruturasList";
import { CategoriasOutrosList } from "@/components/solar/configuracao/CategoriasOutrosList";
import { UseFormReturn, FieldArrayWithId } from "react-hook-form";

interface EstruturasTabProps {
  estruturaFields: FieldArrayWithId<any, "estruturas", "id">[];
  estruturasForm: UseFormReturn<any>;
  categoriasOutros: { categoria: string; itens: string[] }[];
  handleExcluirItemCategoria: (categoria: string, item: string) => void;
}

export const EstruturasTab = ({
  estruturaFields,
  estruturasForm,
  categoriasOutros,
  handleExcluirItemCategoria
}: EstruturasTabProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <EstruturasList 
          fields={estruturaFields}
          form={estruturasForm}
        />
      </div>
      <div>
        <CategoriasOutrosList 
          categorias={categoriasOutros}
          onDeleteItem={handleExcluirItemCategoria}
        />
      </div>
    </div>
  );
};
